import { createContext } from "react"

const AppContext = createContext({
  hovered: null,
  setHovered: null,
  selected: null,
  setSelected: null,
})

export const AppProvider = AppContext.Provider

export default AppContext
